import { VehicleInterface } from "."
import { InputLabel } from "./style"

interface ElementsInterface {
    inputLabel: string,
    gridArea: string,
    field: keyof VehicleInterface,
    type: string
}
type test = keyof VehicleInterface


export const elements: ElementsInterface[] = [

    {
        inputLabel: 'Placa',
        gridArea: 'plate',
        field: 'plate',
        type: 'text'
    },
    {
        inputLabel: 'Modelo',
        gridArea: 'model',
        field: 'model',
        type: 'text'
    },
    {
        inputLabel: 'Ano',
        gridArea: 'year',
        field: 'year',
        type: 'number'
    },
    {
        inputLabel: 'Capacidade de carga',
        gridArea: 'capacity',
        field: 'capacity',
        type: 'number'
    },
    {
        inputLabel: 'Tamanho da carroceria',
        gridArea: 'bodyworkSize',
        field: 'size',
        type: 'number'
    },
    {
        inputLabel: 'Restrição de rodagem',
        gridArea: 'restrictions',
        field: 'restriction',
        type: 'text'
    },
]